import React from 'react'
import { Container, Accordion } from 'react-bootstrap'
import './FAQ.css'

function FAQ() {
    return (
        <section className='faq'>
            <Container fluid className='custom-container'>
                <h2 className='heading'>FAQ</h2>
                <Accordion defaultActiveKey="0" alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>What is a shitcoin?</Accordion.Header>
                        <Accordion.Body>
                            <span className='mb-4 d-inline-block'>
                                A shitcoin is any coin, token or nft which:
                            </span>
                            <ul>
                                <li>Project Rugged (Scammed investors)</li>
                                <li>Went to zero (Lost all value)</li>
                                <li>No longer trading (Delisted from all exchanges)</li>
                                <li>Project could never get on an exchange (Not able to trade)</li>
                                <li>Project which failed (Went out of business)</li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Do you change any fees to use the shitcoin exchange?</Accordion.Header>
                        <Accordion.Body>
                            For each transaction we add a small service fee of $1.50 . These fees help us cover the cost of servers and maintaining blockchain node services.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>What will CoinMarketAlert do with all the shitcoins and nft’s we receive?</Accordion.Header>
                        <Accordion.Body>
                            Short answer is “nothing”. The long answer is we will eventually use these shitty assets to create various datasets and develop analytic products within CoinMarketAlert.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>How will I receive my coupon for the product/service which I select?</Accordion.Header>
                        <Accordion.Body>
                            Directly after the transfer of your shit coins, we will display your coupon code and url (website) where you can redeem your coupon.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>How many shitcoins do I need to send?</Accordion.Header>
                        <Accordion.Body>
                            We don’t care! Send us any amount of that shit in your wallet.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </section>
    )
}

export default FAQ